import { Badge } from '@/components/ui/badge';
import { SessionFeedbackIssue, SessionFeedbackIssueDetails } from '@airreading/common/data';

interface FeedbackIssueBadgeProps {
  feedbackIssue: SessionFeedbackIssue;
  testId?: string;
}

export const FeedbackIssueBadge = ({ feedbackIssue, testId }: FeedbackIssueBadgeProps) => {
  return (
    <Badge className="bg-teal-400 hover:bg-teal-500 cursor-default" data-testid={testId}>
      {SessionFeedbackIssueDetails[feedbackIssue].label}
    </Badge>
  );
};
